import { render } from "./indexRealtorsReserves.vue?vue&type=template&id=ce308242&scoped=true"
import script from "./indexRealtorsReserves.vue?vue&type=script&lang=js"
export * from "./indexRealtorsReserves.vue?vue&type=script&lang=js"

import "./indexRealtorsReserves.vue?vue&type=style&index=0&id=ce308242&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce308242"]])

export default __exports__